import { FC } from 'react';
import { Alert, Card, CardContent } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import ApiService from '../../../../../ApiService';
import Block from '../../../../../components/Block';
import Column from '../../../../../components/Column';

import { AdCreative } from '../../../../../types/AmazonAds';
import { CampaignAdGroup } from '../../../../../types/Campaign';
import { CampaignCreativeDataGridNoRowsOverlay } from '../DataGrid/CampaignCreativeDataGrid';
import CampaignAdGroupCreativeCard from '../Card/CampaignCreativeCard';
import DspAdCreativeUtils from '../../../../../utils/DspAdCreativeUtils';

interface CampaignAdGroupCreativeTabProps {
    campaignAdGroup: CampaignAdGroup;
}

const CampaignAdGroupCreativeTab: FC<CampaignAdGroupCreativeTabProps> = ({ campaignAdGroup }) => {
    const { data, isError } = useQuery<AdCreative[]>({
        enabled: !!campaignAdGroup.id,
        refetchOnWindowFocus: false,
        queryKey: ['campaign/adGroup/dspAdCreatives', campaignAdGroup.campaignId, campaignAdGroup.id],
        queryFn: async () => {
            const { data } = await ApiService.getCampaignAdGroupAdCreatives(campaignAdGroup.id as number);

            return await Promise.all(data.map((creative: AdCreative) => DspAdCreativeUtils.toDspAdCreative(creative)));
        },
    });

    return (
        <Block disableGutters px={3}>
            <Column gap={3}>
                {isError ? (
                    <Alert severity="error">Failed to load ad creatives.</Alert>
                ) : data?.length ? (
                    data?.map((dspAdCreative: AdCreative, index: number) => {
                        return (
                            <CampaignAdGroupCreativeCard
                                slotProps={{
                                    collapsibleCard: {
                                        defaultExpanded: index === 0,
                                    },
                                }}
                                dspAdCreative={dspAdCreative}
                            />
                        );
                    })
                ) : (
                    <Card variant="outlined">
                        <CardContent>
                            <CampaignCreativeDataGridNoRowsOverlay />
                        </CardContent>
                    </Card>
                )}
            </Column>
        </Block>
    );
};

export default CampaignAdGroupCreativeTab;
